var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 7.5C13.3125 7.5 13 7.1875 13 6.75C13 6.34375 13.3125 6 13.75 6H18.25C18.6562 6 19 6.34375 19 6.75V11.25C19 11.6875 18.6562 12 18.25 12C17.8125 12 17.5 11.6875 17.5 11.25V8.5625L11.25 14.7812C10.9688 15.0938 10.5 15.0938 10.2188 14.7812C9.90625 14.5 9.90625 14.0312 10.2188 13.7188L16.4375 7.5H13.75ZM5 8.75C5 7.8125 5.78125 7 6.75 7H10.25C10.6562 7 11 7.34375 11 7.75C11 8.1875 10.6562 8.5 10.25 8.5H6.75C6.59375 8.5 6.5 8.625 6.5 8.75V18.25C6.5 18.4062 6.59375 18.5 6.75 18.5H16.25C16.375 18.5 16.5 18.4062 16.5 18.25V14.75C16.5 14.3438 16.8125 14 17.25 14C17.6562 14 18 14.3438 18 14.75V18.25C18 19.2188 17.1875 20 16.25 20H6.75C5.78125 20 5 19.2188 5 18.25V8.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternal);
export default __webpack_public_path__ + "static/media/External.a842e735b7e909098d015c9ddd7b40b4.svg";
export { ForwardRef as ReactComponent };